import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions } from 'react-redux-form';
import { bindActionCreators } from 'redux';

import { DetailsDashboard } from "../../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { MODAL_CUSTOM_MESSAGE, TABLE_PAGINATION_KEY, Selected_Index } from "../../../../../constants/external-constants";
import { RequestHeaders } from "../../../../common/header-logo/request-header.component";
import OuputFormLayout from "../output-configuration-form.component/output-config-form_layout";
import { OutputConfigurationDetailsActions } from "../../../../../store/external/recharge-reducer/output-configuraton-details/output-configuration-details.reducer";
import { outputConfigurationActions } from "../../../../../store/external/recharge-reducer/output-configuration-reducer/output-configuration.reducer";
import { validateAccessModule } from "../../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";

class OutputConfigDashboard extends Component{
    constructor(props){
        super(props);
        this.state ={
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            viewDetailPage: false,
            showModal: false,
            headerTitle: "OutputConfiguration",
            outputConfigurationId: 0,
            createNew: false,
            isCreateNew: false,
            selectedIndex: Selected_Index.i_Zero
        }

    };

    componentDidMount() {
       this.props.getOutputConfiguration();
        this.props.getOutputConfigurationDropdownlist();

        const recordId = sessionStorage.getItem('tempRecordIdForDetailPage');;
        sessionStorage.removeItem('tempRecordIdForDetailPage');

        if (recordId) {
            this.setState({
                viewDetailPage: true,
                outputConfigurationId: recordId,
                headerTitle: "OutputConfigurationDetails",
                selectedIndex: Selected_Index.i_One
            });
            this.props.getOutputConfigurationDetailsForm(recordId);
        } else {
            this.props.getOutputConfigurationDetailsForm(0);
        }
    };

    componentWillUnmount() {
        this.props.setDefaultOutputConfiguration();
    };

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractOutputConfiguration();
        }
    };

    loading = () => {
        return (
            <NoSubscription />
        );
    };

    displaySearchBox = () => {
        this.setState(prev => ({
            displaySearch: !prev.displaySearch
        }));
    };

    resizePage = (value) => {
        const { getOutputConfiguration, resizeOutputConfigurationPage } = this.props;
        resizeOutputConfigurationPage(value);
        getOutputConfiguration();
    };

    applyFilter = (isApply) => {
        const { getOutputConfiguration, applyOutputConfigurationFilter } = this.props;
        applyOutputConfigurationFilter(isApply);
        getOutputConfiguration();
    };

    handleCreateNewConf(buttonType){
        if(buttonType==="ok")
        {
            this.setState({                
                showModal: false,
                viewDetailPage: true,
                headerTitle:"OutputConfigurationDetails"
            })
        } else {
            this.setState({showModal: false })
        }
    };

    handleCreateNewAction = () => {
        this.props.resetAllForm();
        this.setState({
            showModal: true,
            outputConfigurationId: 0,
            isCreateNew: true
        })
    };

    handleCloseForm = () => {
        this.setState({
            outputConfigurationId: 0,
            viewDetailPage: false,
            createNew: false,
            headerTitle: "OutputConfiguration",
            isCreateNew: false,
            selectedIndex: Selected_Index.i_Zero
        })
    }

    handleRowClick = (isShow, rowItem, hasLink) => {
        if (rowItem != null) {
            if (hasLink) {
                this.setState({
                    selectedIndex: Selected_Index.i_Two
                })
            }
            this.setState({
                viewDetailPage: isShow
                , outputConfigurationId: rowItem.OutputConfigurationID
                , headerTitle: "OutputConfigurationDetails"
            })
        }
        else {
            this.setState({ viewDetailPage: isShow, headerTitle: "OutputConfiguration" });
        }
    };

    render() {
        const { outputConfiguration, getOutputConfiguration, setOutputConfigurationColSearchStr, sortOutputConfigurationItems, saveOutputConfigurationCustomCols, addOutputConfigurationFilter, removeOutputConfigurationFilter } = this.props;
        const { headerTitle, selectedIndex } = this.state;
        const { Selected, Available, Default } = this.props.outputConfiguration.outputConfigurationItems.Columns;


        const { outputConfigurationDetailsForm }  = this.props
        const { outputConfigurationDropdownlist } = this.props.outputConfigurationDetails;

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdOutputConfigurationR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdOutputConfigurationyRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdOutputConfigurationRW])


        return (

            <div className="invoice-wrapper-container inventory-report-component">
                <ConfirmationNotificationModal
                    show={this.state.showModal}
                    message={MODAL_CUSTOM_MESSAGE.create_new_output_configuration}
                    title={"Add New"}
                    handleModal={this.handleCreateNewConf.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <RequestHeaders headerTitle={headerTitle} /> 
                <div className="request-table data-table fit-width">
                    {
                        !outputConfiguration.isOutputConfigurationLoaded ? (
                            this.loading()
                        ) : (
                            this.state.viewDetailPage ? (
                                <OuputFormLayout
                                    outputConfigurationId={this.state.outputConfigurationId}
                                    handleClose={this.handleCloseForm}
                                    outputConfigurationDropdownlist={outputConfigurationDropdownlist}
                                    outputConfigurationDetailsForm={outputConfigurationDetailsForm}
                                    isCreateNew={this.state.isCreateNew}
                                    getOutputConfiguration={getOutputConfiguration}
                                    selectedIndex={selectedIndex}
                                />
                            ) : (
                                <DetailsDashboard
                                    data={outputConfiguration.outputConfigurationItems.TableFilterData}
                                    translation={""}
                                    addAction={addOutputConfigurationFilter}
                                    removeAction={removeOutputConfigurationFilter}
                                    applyAction={this.applyFilter}
                                    customClassName={"output-configuration"}
                                    createNewAction={this.handleCreateNewAction}
                                    viewSearchAction={this.displaySearchBox}
                                    firstList={Available}
                                    secondList={Selected}
                                    defaultList={Default}
                                    saveAction={saveOutputConfigurationCustomCols}
                                    extractAction={(e) => this.onClickExtract(e)}
                                    isReadOnly={isReadOnly}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                >
                                    {outputConfiguration.outputConfigurationItems ? (
                                        <TablePagination
                                            key={TABLE_PAGINATION_KEY.outputConfiguration}
                                            classNameWrapper="overflow-auto"
                                            columns={outputConfiguration.outputConfigurationItems.Headers}
                                            pageList={outputConfiguration.outputConfigurationItems.Data}
                                            pages={outputConfiguration.outputConfigurationItems.Pagination}
                                            rowClickAction={(value, hasLink) => { this.handleRowClick(true, value, hasLink) }}
                                            paginationAction={getOutputConfiguration}
                                            onColumnClick={sortOutputConfigurationItems}
                                            onColumnSearch={() => getOutputConfiguration(0)}
                                            onColumnSearchChange={setOutputConfigurationColSearchStr}
                                            isColSearchShow={this.state.displaySearch}
                                            resizePage={this.resizePage}
                                            totalPage={outputConfiguration.outputConfigurationItems.Pagination.TotalEntries}
                                            hideStatusIcon={true}
                                        />
                                    ) : (
                                        this.loading()
                                    )}
                                </DetailsDashboard>
                            )
                        )
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    state => {
        const { outputConfiguration, outputConfigurationDetails } = state;
        const { outputConfigurationDetailsForm, forms: { outputConfigurationDetailsForm: { $form } } } = state.form;
        return {
            outputConfiguration
            , outputConfigurationDetails
            , outputConfigurationDetailsForm
            , $form
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, outputConfigurationActions, OutputConfigurationDetailsActions),
        dispatch
    )
)(OutputConfigDashboard));
